<template lang="pug">
tr(:id="id" :class="showRulesForThisDay")
  td.more-padding-cell
    .draggable-cursor-move
      span.handle.cursor-move
        svg.icon.icon-drag-drop
          use(xlink:href="#icon-drag-drop")
  td.more-padding-cell 
    div.business-rule-name 
      h3(:title="businessRule.Description") {{ businessRule.Description }}
      p(v-if="businessRule.StartDate || businessRule.EndDate") from {{ businessRule.displayStartDate }} to {{ businessRule.displayEndDate }}
      p  from {{ businessRule.displayStartTime }} to {{ businessRule.displayEndTime }}
  td.more-padding-cell 
    div.business-rule-daily-rules 
      p.status {{ businessRule.Available ? 'Open' : 'Closed'  }}
      div(
        v-if="businessRule.Weekdays.length === 7"
        class="activity-label activity-label--small activity-label--all"
        title="All resources"
        style="background-color: transparent;"
        ) all
      p(v-else).days {{ availableDays }}
  td.more-padding-cell
    div.business-rule-resources
      div(
        v-if="businessRule.ActivityKeys.length === selectableActivities.length"
          class="activity-label activity-label--small activity-label--all"
          title="All resources"
          style="background-color: transparent;"
        ) all
      div(v-else)
        div(
          v-for="activity in businessRuleResources"
          :key="`${activity.key}-${businessRule.Key}`"
          class="activity-label activity-label--small"
          :title="activity.description" 
          :style="`background-color: ${activity.color};`"
          ) {{ activity.initials }}
    
  td.table__cell.table__cell--actions.less-padding-cell
    .table__actions.business-rule-actions
      a.table__action.business-rule-action(:href="`/schedule/${businessRule.Key}/edit`")
        BriqIcon(name="icon-input-edit-icon")
      button.table__action.business-rule-action(type="button" data-toggle="modal" data-target="#briq-modal" :data-url="`/schedule/${businessRule.Key}/delete`")
        BriqIcon(name="icon-input-trash-icon")
</template>

<script>
export default {
  name: 'BusinessRuleRow',
  props: {
    businessRule: Object,
    activitiesLookup: Array,
    scheduleKeys: Array,
    rulesForThisDay: Boolean,
  },
  computed: {
    id() {
      return `business-rule-${this.businessRule.Key}`
    },
    availableDays() {
      return this.businessRule.Weekdays.length === 7 ? 'all' : this.businessRule.Weekdays.join(', ')
    },
    selectableActivities() {
      return this.activitiesLookup.filter(activity => activity.ResourceType != 'ResourceGroup')
    },
    businessRuleResources() {
      return this.activitiesLookup.filter(activity =>
        this.businessRule.ActivityKeys.includes(activity.key),
      )
    },
    showRulesForThisDay() {
      return this.rulesForThisDay && this.scheduleKeys.includes(this.businessRule.Key)
        ? 'rules-for-this-day'
        : null
    },
  },
}
</script>

<style scoped lang="stylus">
.draggable-cursor-move
  width 14px
  margin auto

// stylus can't seem to deal with the removal of brackets and semicolons in this one
tr.rules-for-this-day {
  -webkit-box-shadow: inset 3px 0px 0px 0px #009BFF;
  -moz-box-shadow: inset 3px 0px 0px 0px #009BFF;
  box-shadow: inset 3px 0px 0px 0px #009BFF;
}

td.less-padding-cell
  padding 8px 10px


td.more-padding-cell
  padding 20px 20px


span.handle.cursor-move
  margin-right 0.3em


svg.icon.icon-drag-drop
  vertical-align middle


.business-rule-name
    width 100%
    word-break break-word

    h3
        {typeBold}
        max-height 24px
        overflow hidden
        text-overflow ellipsis
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        margin-bottom space-XS


    p
        {typeSmall}
        color #798696
        margin 0



.business-rule-daily-rules
    p.status
        {typeBold}
        max-height 1.12
        margin 0


    p.days
        {typeSmall}
        color #798696
        margin 0



.business-rule-actions
  justify-content normal

  :before
    width 0px



.business-rule-action
  padding 0 space-XS 0 0
  &:last-child
    padding-right 0



.hide
  visibility hidden
</style>
